<template>
  <client-only>
    <v-row :class="contentClass">
      <v-col>
        <div
          class="scrollbar-17 company-description-box"
          :dir="langCheck ? 'ltr' : 'rtl'"
          :class="langCheck ? 'pr-4' : 'pl-4'"
        >
          <p
            class="ma-0 display-16 company-description"
            :class="contentClass"
            :dir="langCheck ? 'rtl' : 'ltr'"
          >
            {{ content }}
          </p>
        </div>

        <!-- <div v-else>
          <h3>{{ title }}</h3>
          <p class="ma-0 display-22" :class="contentClass">{{ content }}</p>
        </div> -->
      </v-col>
    </v-row>
  </client-only>
</template>


<script>
// import truncate from 'lodash/truncate';

// const MOBILE_SHORT = 300;
// const PC_SHORT = 250

export default {
  components: {},

  props: {
    toShowMore: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
      required: false,
    },
    title: {
      type: String,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    fontSizeTitle: {
      type: String,
      required: false,
      default: 'display-36',
    },
    fontSizeContent: {
      type: String,
      required: false,
      default: 'display-24',
    },
    titleClass: {
      type: String,
    },

    contentClass: {
      type: String,
    },

    numOfEmployees: {
      type: String,
    },
    industry: {
      type: String,
    },
    numOfBranches: {
      type: Number,
    },
    showCompanyDetails: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      allContent: false,
      showMore: false,
      hideBtn: false,
    };
  },

  mounted() {
    this.classForTitle;
  },

  computed: {
    langCheck() {
      var position = this.content.search(/[\u0590-\u05FF]/);
      if (position >= 0) {
        return true;
      } else {
        return false;
      }
    },
    classForTitle() {
      return this.titleClass + ' ' + this.fontSizeTitle;
    },

    // shortTextDisplay() {
    //   return !this.$vuetify.breakpoint.smAndUp ? true : false;
    // },

    // shortenedText() {
    //   let text = '';

    //   if (this.content.length > MOBILE_SHORT && !this.allContent) {
    //     text = truncate(this.content, {
    //       length: MOBILE_SHORT,
    //       separator: ' ',
    //     });

    //     this.showMore = true;
    //   } else {
    //     this.showMore = false;
    //     text = this.content;
    //   }
    //   return text;
    // },
  },

  // methods: {
  //   fullDisplay() {
  //     this.allContent = true;
  //     this.hideBtn = true;
  //   },

  //   showLess() {
  //     this.allContent = false;
  //     this.hideBtn = false;
  //   },
  // },

  // beforeDestroy() {
  //   this.allContent = false;
  // },
};
</script>

<style lang="scss" scoped>
// .company-text {
//   color: #fff;
//   margin: 5px auto;

//   max-height: 371px;
// }

.company-about {
  max-width: 300px;
  max-height: 371px;
  font-size: 24px;
  overflow: auto;
  // direction: rtl;
  margin: 0 auto;
}

.company-description-box {
  overflow-y: overlay;
  max-height: 300px;
}
.company-description {
  // padding-right: 25px;
  // direction: rtl;
}

.pumpkin-title {
  color: $primary;
}

.pumpkin-title-mobile {
  margin: 0 auto;
  color: $primary;
  font-size: 16px;
}

.company--info-disp {
  width: 74px;
  padding: 1px 0;
  object-fit: contain;
  border-radius: 12.5px;
  display: block;
  color: #fff;
  text-align: center;
  border: 1px solid $primary;
  margin: 10px auto;
}

@media only screen and (min-width: 600px) {
  .company-about {
    text-align: right;
    max-width: inherit;
  }
}
</style>
